import React from "react";
import "./page4styles.css";
import {motion} from "framer-motion";
import page4Img1 from '../../Assets/1x/Asset 26.png';
import page4Img2 from '../../Assets/1x/Asset 27.png';

function Page4() {
    // detect mobile breakpoint
    //const isMobile = window.innerWidth <= 768;
    const isMobile = true;

    return (
        <div className="page4">
            <div className="page4-block">
                <div className="page4-block-title-block">
                    {/* First image appears from the left */}
                    <motion.img
                        src={page4Img1}
                        className="page4-block-main-img"
                        initial={{opacity: 0, x: -100}}
                        whileInView={{opacity: 1, x: 0}}
                        transition={{duration: 1}}
                        viewport={{ once: isMobile }}
                    />
                    {/* Second image appears from the right */}
                    <motion.img
                        src={page4Img2}
                        className="page4-block-second-main-img"
                        initial={{opacity: 0, x: 100}}
                        whileInView={{opacity: 1, x: 0}}
                        transition={{duration: 1, delay: 0.2}}
                        viewport={{ once: isMobile }}
                    />
                </div>
                <div className="page4-block-text-block">
                    <motion.p
                        initial={{opacity: 0, y: 20}}
                        whileInView={{opacity: 1, y: 0}}
                        transition={{duration: 1, ease: "easeOut"}}
                        viewport={{ once: isMobile }}
                    >
                        ვაჟა ფაჯიშვილი პროფესიით
                        ეკონომისტია, ახალგაზრდობაში
                        მთამსვლელობა იტაცებდა და
                        მთაში დადიოდა. 2000 წელს შხარის
                        მწვერვალიდან დაშვებისას, ნაპრალში გადავარდა და
                        14 მოტეხილობა მიიღო. ფეხები, ნეკნები, თავი
                        დამტვრეული ჰქონდა... მაშველებმა ამოიყვანეს.
                        როგორც ამბობს, მომაკვდავი იყო, გადარჩენის შანსი არ
                        არსებობდა, მაგრამ გადარჩა. მკურნალობა დიდხანს
                        გაგრძელდა. იმ პერიოდიდან რაღაცები ბუნდოვნად ახსოვს...
                        ვაჟა ფაჯიშვილი „კვირის პალიტრას" დაარსების
                        დღიდან კითხულობს. ნომერი არ ჩაუგდია.
                        ამიტომ, გაზეთი მისთვის საავადმყოფოშიც მოჰქონდათ.
                        გაჭირვებით, მაგრამ მაინც კითხულობდა. ერთ-ერთ ნომერში
                        ამ პროექტის შესახებ ამოიკითხა და შვილებისთვის წერილის
                        მიწერა მოუნდა... დაიწყო წერა, მაგრამ არ ეგონა, რომ 25 წლის
                        შემდეგ ცოცხალი იქნებოდა და იმ ტრავმებს გადაურჩებოდა...
                        სასიხარულო ისაა, რომ 2025 წელს გასახსნელი წერილებს
                        წასაღებად თავად მოაკითხა, რადგან მისი ვაჟი ახლა
                        ამერიკაშია, ხოლო გოგოს კი ბარათი თავად გადასცა.
                    </motion.p>
                </div>
            </div>
        </div>
    );
}

export default Page4;
